import { AddressType } from '@enums/transport.enum';

export interface TransportAddressListResponse {
    count: number;
    next?: null | string;
    previous?: null | string;
    results: TransportAddress[];
    [property: string]: any;
}

export class TransportAddressContact {
    id?: number |null;
    name: string = "";
    phone: string = "";
    email: string = "";
    is_principal: boolean = false;
    send_notifications: boolean = false;
    [property: string]: any;
}

export class TransportAddressOpeningHour {
    id?: number |null;
    weekday: number = 0;
    open_time: string = "";
    close_time: string = "";
    [property: string]: any;
}

export class TransportAddress {
    id: number = 0;
    title: string = "";
    longitude: number | null = null;
    latitude: number | null = null;
    client?: number = 0;
    country?: string;
    city?: string;
    postal_code?: string;
    province?: string;
    street_address?: string;
    address_complement: string = "";
    address_type: AddressType = AddressType.PRIVATE;
    contacts: TransportAddressContact[] = [];
    client_name?: string = "";
    subentity: string = "";
    subentity_name: string = "";
    opening_hours?: TransportAddressOpeningHour[];
    opening_hours_summary: string = "";
    created_date: Date | null = null;
    modified_date: Date | null = null;
    state: boolean = true;
    is_favorite: boolean = false;
    [property: string]: any;
    
    constructor(data: Partial<TransportAddress> = {}) {
        if (data.id !== undefined) this.id = data.id;
        if (data.title !== undefined) this.title = data.title;
        if (data.longitude !== undefined) this.longitude = data.longitude;
        if (data.latitude !== undefined) this.latitude = data.latitude;
        if (data.client !== undefined) this.client = data.client;
        if (data.country !== undefined) this.country = data.country;
        if (data.city !== undefined) this.city = data.city;
        if (data.postal_code !== undefined) this.postal_code = data.postal_code;
        if (data.province !== undefined) this.province = data.province;
        if (data.street_address !== undefined) this.street_address = data.street_address;
        if (data.address_complement !== undefined) this.address_complement = data.address_complement;
        if (data.address_type !== undefined) this.address_type = data.address_type;
        if (data.state !== undefined) this.state = data.state;
        if (data.client_name !== undefined) this.client_name = data.client_name;
        if (data.subentity !== undefined && data.subentity !== null) this.subentity = String(data.subentity);
        if (data.subentity_name !== undefined) this.subentity_name = data.subentity_name;
        if (data.opening_hours !== undefined && data.opening_hours !== null) {
            this.opening_hours = (data.opening_hours || []).map(oh => {
                const h = new TransportAddressOpeningHour();
                if ((oh as any).id !== undefined) h.id = (oh as any).id;
                if ((oh as any).weekday !== undefined) h.weekday = (oh as any).weekday;
                if ((oh as any).open_time !== undefined) h.open_time = (oh as any).open_time;
                if ((oh as any).close_time !== undefined) h.close_time = (oh as any).close_time;
                return h;
            });
        }
        if (data.opening_hours_summary !== undefined) this.opening_hours_summary = data.opening_hours_summary;
        if (data.contacts !== undefined && data.contacts !== null) {
            this.contacts = (data.contacts || []).map(c => {
                const ct = new TransportAddressContact();
                if ((c as any).id !== undefined) ct.id = (c as any).id;
                if ((c as any).name !== undefined) ct.name = (c as any).name;
                if ((c as any).phone !== undefined) ct.phone = (c as any).phone;
                if ((c as any).email !== undefined) ct.email = (c as any).email;
                if ((c as any).is_principal !== undefined) ct.is_principal = (c as any).is_principal;
                if ((c as any).send_notifications !== undefined) ct.send_notifications = (c as any).send_notifications;
                return ct;
            });
        }
        if (data.created_date !== undefined && data.created_date !== null) {
            this.created_date = data.created_date instanceof Date ? data.created_date : new Date(data.created_date as any);
        }
        if (data.modified_date !== undefined && data.modified_date !== null) {
            this.modified_date = data.modified_date instanceof Date ? data.modified_date : new Date(data.modified_date as any);
        }
        if (data.is_favorite !== undefined) this.is_favorite = data.is_favorite;
    }

    static fromJson(json: any): TransportAddress {
        return new TransportAddress(json);
    }
}
